import type { AosFaction } from "./factions";

export const StormcastEternals: AosFaction = {};
